export default "__VITE_ASSET__C7_5MYDB__"